import * as React from "react";
import Container from '@mui/material/Container';
import ComingSoonComponent from './ComingSoonComponent'

const ComingSoonPage = (props) => { 

  return (
    <div className="App">
      <Container maxWidth={false}>
        {/* <h2 className="heading-title">WA Billing</h2> */}
        <ComingSoonComponent />
      </Container>

    </div>
  );
}
export default ComingSoonPage;
